module.exports = __webpack_public_path__ + "media/images/explore-b09e914c098ceeff9f16303fedb4cd33.png";